import { McpAccessRO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";

const getMcpAccess = async (companyId: number): Promise<McpAccessRO> => {
  const { data } = await apiService.get<McpAccessRO>(
    Endpoints.Companies.Get.McpAccess(companyId),
  );
  return data;
};

const updateMcpAccess = async (
  companyId: number,
  enabled: boolean,
): Promise<McpAccessRO> => {
  const { data } = await apiService.put<McpAccessRO>(
    Endpoints.Companies.Put.McpAccess(companyId),
    { enabled },
  );
  return data;
};

export { getMcpAccess, updateMcpAccess };
